export const mondayAbbreviatedLowercase = "Jqa";
export default {mondayAbbreviatedLowercase};